import { render } from "./EditLiquidation2.vue?vue&type=template&id=321d1d6a"
import script from "./EditLiquidation2.vue?vue&type=script&lang=js"
export * from "./EditLiquidation2.vue?vue&type=script&lang=js"

import "./EditLiquidation2.vue?vue&type=style&index=0&id=321d1d6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__